import React, { Component } from 'react';
import { format } from 'date-fns';
import EditReminderModal from './EditReminderModal';

class ReminderCard extends Component {
  render() {
    const reminder = this.props.reminder;
    return <div className='reminder-card'>
      <div className='reminder-card-info'>
        <div className='reminder-date'>{format(new Date(reminder.reminder_date), 'YYYY MMMM D')}</div>
        <div className='reminder-title'>{reminder.title}</div>
      </div>
      <EditReminderModal
        reminder={reminder}
        reminderTypes={this.props.reminderTypes}
        refreshList={this.props.refreshList}
      />
   </div>
  }
}

export default ReminderCard;


// WEBPACK FOOTER //
// ./src/Account/RemindMe/ReminderCard.js